var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isaudio)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.playaudio(_vm.audio)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }